module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-t-mobile-00.2.6ebe1769.jpg";